import { Action } from 'redux';

import { AdminAllowAcceleration, AdminDisallowAcceleration } from '../../bootstrap/redux/actions/AppActionTypes';
import { IAccelerationTaskInfo } from '../models/IAccelerationTaskInfo';

export interface DataAccelerationTaskMenuAction extends Action {
  tasks: IAccelerationTaskInfo[];
}

export function adminAllowAcceleration(tasks: IAccelerationTaskInfo[]): DataAccelerationTaskMenuAction {
  return {
    type: AdminAllowAcceleration,
    tasks
  };
}

export function adminDisallowAcceleration(tasks: IAccelerationTaskInfo[]): DataAccelerationTaskMenuAction {
  return {
    type: AdminDisallowAcceleration,
    tasks
  };
}

export enum DataAccelerationType {
  adminAllowAcceleration = 'AdminAllowAcceleration',
  adminDisallowAcceleration = 'AdminDisallowAcceleration'
}
